import { Fragment, useState, useEffect } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, TextField,
} from '@mui/material';
import SellIcon from '@mui/icons-material/Sell';
import sendRequest from '../utils/sendRequest';
import { MenuButtonIcon, CancelButton, WarningButton, SubmitButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function  CreateSkusAndPoDialog({
  buttonLoading = null, setButtonLoading = null, po_doc_id, poName, type,
  addSnackbar, fetchPos = null, currentPoId, fetchPoDetails = null, isIcon,
  upcGenerationAllowed, upcGenerationRequested,
}) {
  const [open, setOpen] = useState(false);
  const [loadingSkuPo, setLoadingSkuPo] = useState(false);
  const [poId, setPoId] = useState(currentPoId);
  const [formFilled, setFormFilled] = useState(false);
  const [loadingUpcApproval, setLoadingUpcApproval] = useState(false);

  const fetchAction = fetchPos ? fetchPos : fetchPoDetails;

  useEffect(() => {
    const filled = (poId !== "" && !isNaN(poId));
    setFormFilled(filled);
  }, [type, poId]);

  const handleOpen = () => {
    setOpen(true);
    setPoId(currentPoId);
  };

  const handleClose = () => {
    if (!loadingSkuPo && !loadingUpcApproval) {
      setOpen(false);
    }
  };

  const handlePoIdChange = (e) => {
      const val = e.target.value;
      if (val === "") {
          setPoId("");
          return;
      }
      const num = parseInt(val);
      if (!isNaN(num) && num >= 0) {
          setPoId(num);
      }
  };

  const createSkusAndPo = async () => {
    if (setButtonLoading) setButtonLoading(true);
    setLoadingSkuPo(true);
    try {
      const isAts = type === 'ATS';
      if (isAts && poId === 0) {
        throw Error("Invalid Purchase Order ID.");
      }
      let query = `purchase-orders/create-skus-and-po?po_type=${type}&po_doc_id=${po_doc_id}`;
      if (!isAts) query += `&po_id=${poId}`;
      const response = await sendRequest(query);
      fetchAction();
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      handleClose();
      if (setButtonLoading) setButtonLoading(false);
      setLoadingSkuPo(false);
    }
  }

  const requestUpcGenerationApproval = async () => {
    setLoadingUpcApproval(true);
    try {
      let query = `purchase-orders/request-upc-generation?po_doc_id=${po_doc_id}`;
      const response = await sendRequest(query);
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingUpcApproval(false);
      handleClose();
    }
  }

  return (
    <Fragment>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Create SKUs & PO"}
        text={"Create SKUs & PO"}
        icon={SellIcon}
        onClick={handleOpen}
        disabled={buttonLoading}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingSkuPo}
      >
        <CustomDialogTitle
          header={"Create SKUs and PO"}
          poName={poName}
        />
        {( !(type === 'ATS') ) && (
          <DialogContent>
            <DialogContentText>
              Please enter the SellerCloud PO ID
            </DialogContentText>
            <TextField
              autoComplete="off"
              autoFocus
              required
              type="text"
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              value={poId}
              variant="standard"
              fullWidth
              onChange={handlePoIdChange}
            />
          </DialogContent>
        )}
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingSkuPo || loadingUpcApproval}>Cancel</CancelButton>
          {!upcGenerationAllowed && !upcGenerationRequested && !(type === 'OAK' || type === 'ATS') && (
            <WarningButton
              showSpinner={loadingUpcApproval}
              text={"Request UPC Generation"}
              onClick={() => requestUpcGenerationApproval()}
              disabled={loadingUpcApproval || loadingSkuPo}
            />
          )}
          <SubmitButton
            showSpinner={loadingSkuPo}
            text={"Create SKUs and PO"}
            onClick={() => createSkusAndPo()}
            disabled={loadingSkuPo || !formFilled || loadingUpcApproval}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}
